'use strict';

module.exports = function setRequestPending (request, requestArgs, meta = {}) {
  return {
    type: 'DATA_CONNECTOR_SET_REQUEST_PENDING',
    isStoreSetAction: true,
    meta: {
      reference: request.referenceFor(...requestArgs),
      ...meta,
    },
  };
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/setRequestPending.js